import { getApiFilters } from '@react/search/helpers';
import { usePrefetch } from '@react/services/api';
import { ID, PAGE_NUMBER, PAGE_SIZE } from '@sly/core/constants/filters';
import dynamic from 'next/dynamic';
import { useCallback, useMemo, useState } from 'react';

const GoogleMap = dynamic(
  /* #__LOADABLE__ */ () =>
    import(
      /* webpackChunkName: "chunkGoogleMap" */ '@react/search/components/Map'
    ),
  {
    ssr: false,
  }
);

export const SearchMap = ({
  filtersHeight,
  headerHeight,
  query,
  onFilterChange,
  entities,
  meta,
  hoveredCommunity,
  cursor,
  currentFilters,
}) => {
  const apiFilters = getApiFilters(currentFilters);
  const pinsApiFilters = useMemo(() => {
    return { ...apiFilters, [PAGE_SIZE]: 1000, [PAGE_NUMBER]: 0 };
  }, [apiFilters]);

  const searchEntity = useCallback(
    (pin) => entities.find((entity) => entity.id === pin?.id),
    [entities]
  );

  const { requestInfo: pinsRequestInfo } = usePrefetch(
    'getCommunityPins',
    pinsApiFilters,
    {
      keepLastRequest: true,
    }
  );

  const pins = useMemo(
    () =>
      (pinsRequestInfo.normalized || []).reduce((acc, pin) => {
        acc.push({
          entity: searchEntity(pin),
          ...pin,
        });
        return acc;
      }, []),
    [pinsRequestInfo, entities]
  );

  const [selectedPin, setSelectedPin] = useState(null);
  const selectedApiFilters = useMemo(() => {
    return { ...apiFilters, [ID]: selectedPin?.id };
  }, [apiFilters, selectedPin]);

  const { requestInfo: selectedRequestInfo } = usePrefetch(
    'getSearchPage',
    selectedApiFilters,
    {
      shouldBail: !selectedPin || !!selectedPin.entity,
    }
  );

  const selectedCommunity = useMemo(() => {
    if (selectedPin?.entity) {
      return selectedPin.entity;
    }
    if (
      selectedPin &&
      selectedRequestInfo?.hasFinished &&
      selectedRequestInfo?.normalized?.length &&
      selectedRequestInfo.normalized[0].id == selectedPin.id
    ) {
      return selectedRequestInfo.normalized[0];
    }
    return selectedPin;
  }, [selectedPin, selectedRequestInfo]);
  const [markerHover, setMarkerHover] = useState(null);

  return (
    <GoogleMap
      mapId='bf51a910020fa25a'
      query={query}
      pins={pins}
      meta={meta}
      onFilterChange={onFilterChange}
      onMarkerClick={setSelectedPin}
      onMarkerHover={setMarkerHover}
      selectedCommunity={selectedCommunity}
      selectedHover={markerHover}
      hoveredCommunity={hoveredCommunity}
      cursor={cursor}
      filtersHeight={filtersHeight}
      headerHeight={headerHeight}
    />
  );
};
